module.exports = __webpack_public_path__ + "img/ic_moderator.cac96df8.svg";